<template>

    <div class="progress-monitor-step-2">

        <p>
            Select a data-collection method to monitor the student during the intervention:
        </p>

        <b-card no-body class="mb-3"
                v-for="method in config.progressMonitor.collectionMethods"
                v-if="method.enabled">
            <b-card-header>
                <b-form-radio required
                              @click="collectionMethodSelected(method)"
                              v-model="docData.collectionMethod"
                              :value="method.title">
                    {{ method.title }}
                </b-form-radio>
            </b-card-header>
            <b-card-body v-if="docData.collectionMethod == method.title">
                <b-alert show variant="info">
                    <div v-html="method.template"></div>
                </b-alert>

                <!-- select preset format -->
                <b-dropdown variant="primary" class="m-md-2"
                            text="Select a preset format...">
                    <b-dropdown-item v-for="format in method.formats"
                                     @click="setFormatOptions(format.min, format.max, format.title, format.alias)">
                        {{ format.min }}-{{ format.max }}: {{ format.title }}
                    </b-dropdown-item>
                </b-dropdown>

                <b-form-group label="The lowest possible rating is:">
                    <b-form-input type="text" required
                                  v-model="docData.formatMin"/>
                </b-form-group>
                <b-form-group label="The highest possible rating is:">
                    <b-form-input type="text" required
                                  v-model="docData.formatMax"/>
                </b-form-group>
                <b-form-group label="This format will be referred to as:">
                    <b-form-input type="text" required
                                  v-model="docData.formatTitle"/>
                </b-form-group>

            </b-card-body>
        </b-card>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ProgressMonitorStep2",
        mixins: [ToolMixin],
        computed: {
            thisStepIsValid() {
                const fields = [
                    this.docData.formatMin,
                    this.docData.formatMax,
                    this.docData.formatTitle,
                    this.docData.collectionMethod
                    ]
                return _.every(fields, (f) => {
                    return f === 0 || (f != '' && !_.isNil(f))
                })
            }
        },
        methods: {
            setFormatOptions(min, max, title, alias) {
                // console.log('setFormatOptions', min, max, title, alias);
                this.docData.formatMin = min
                this.docData.formatMax = max
                this.docData.formatTitle = alias
                // console.log(this.docData)
            }
        }
    })

</script>


